import type {TextStylesObject} from '@PosterWhiteboard/classes/text-styles.class';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';
import type {WordObject} from '@PosterWhiteboard/items/transcript-item/subtitle/word/word.types';
import type {SubtitleTemplateType} from '@PosterWhiteboard/items/transcript-item/subtitle/template-styles.types';
import type {SerializedShadowOptions} from '@postermywall/fabricjs-2';
import type {ShadowOrGlowOptionsObject} from '@Utils/fabric-shadow.util';

export const SUBTITLE_TEMPLATE_STYLE_THUMBS_URL = 'poster-editor-thumbnails/ai-subtitles-template-presets-previews/';

export interface SubtitleObject {
  subtitleUID: string;
  text: string;
  startTime: number;
  endTime: number;
  hasUserEdited: boolean;
  sentenceTextStyles: TextStylesObject;
  activeWordTextStyles: TextStylesObject;
  shadow: SerializedShadowOptions | null;
  backgroundFill: FillObject;
  backgroundBorderRadius: number;
  selectedTemplateId: string;
  animationStyle: SubtitleTemplateType;
  words: WordObject[];
}

export interface StartAndEndIndicesOfWord {
  start: number;
  end: number;
}

export interface SubtitleStyles {
  sentenceTextStyles: TextStylesObject;
  activeWordTextStyles: TextStylesObject;
  shadow: ShadowOrGlowOptionsObject | null;
  backgroundFill: FillObject;
  backgroundBorderRadius: number;
}

export interface SubtitleStylesAndAnimation extends SubtitleStyles {
  animationStyle: SubtitleTemplateType;
}
